<div class="ml-4">
    <div class="row">
        <h1> IDM Configuration (Okta)</h1>
    </div>

    <re-alert *ngIf="alert" [type]="alert.type" (close)="alert = null">{{ alert.message }}</re-alert>

    <div class="row">
        <p> This screen is used to configure Okta settings for the product applications to enable SSO.</p>
    </div>

    <div class="row">
        <div class="col-md-4 pl-0">
            <h3>Customer Name</h3>
            <p>{{ customerName }}</p>
        </div>
        <div class="col-md-4">
            <h3>CRM ID</h3>
            <p>{{ crmId }}</p>
        </div>
    </div>

    <div class="mt-2 mb-2" *ngIf="!editableForm && !loading">
        <div class="row mt-2 mb-2">
            <div class="col-md-2 col-lg-2 col-xl-2">ClientId: </div>
            <div class="col-md-10 col-lg-10 col-xl-10">
                {{ clientId ? clientId : 'No Client ID' }}
                <span style="cursor: pointer; margin-left: 5px;" (click)="copyText(typeOfData.ClientID)" *ngIf="clientId">
                    <span style="color: blue;" class="fa fa-clipboard"></span> copy
                </span>
            </div>
         </div>
         <div class="row mt-2 mb-2">
            <div class="col-md-2 col-lg-2 col-xl-2">Issuer: </div>
            <div class="col-md-10 col-lg-10 col-xl-10">
                {{ issuer ? issuer : 'No Issuer' }}
                <span style="cursor: pointer; margin-left: 5px;" (click)="copyText(typeOfData.Issuer)" *ngIf="issuer">
                    <span style="color: blue; margin-left: 5px;" class="fa fa-clipboard"></span> copy
                </span>
            </div>
        </div>
    </div>

    <div class="row mt-3" *ngIf="!loading">
        <p><a href="javascript:void()" style="text-decoration:none;" (click)="openInfoModal();">Click here</a> for sample sign in and sign out redirect URI's.</p>
    </div>

    <div class="row mt-3" *ngIf="!loading">
        <button *ngIf="showEditButton && !editableForm && !editing" (click)="edit()" class="btn btn-primary mr-2">Edit</button>
    </div>

    <!-- Form for Sign in and Sign out URI's -->
    <form class="mt-2" style="display: flex; min-height: 100vh; flex-direction: column;" id="oktaConfigurationForm" [formGroup]="oktaConfigurationForm" (ngSubmit)="onSubmit()" *ngIf="!loading">

        <div class="row" [ngClass]="showEditButton ? 'disable-click' : 'enable-click'">
            <div class="mt-2 mr-5">
                <label for="signInUri">Sign-in redirect URIs</label>
            </div>
            <div>
                <div formArrayName="signInRedirectUris" *ngFor="let uri of oktaConfigurationForm.get('signInRedirectUris')['controls']; let i = index;">
                    <div [formGroupName]="i">
                        <input style="width: 400px;" class="p-1" type="text" formControlName="signInUri" [ngClass]="{'mt-2': showEditButton, 'mb-2' : showEditButton }">
                        <button class="ml-2 mt-1 mb-1 btn btn-danger" (click)="removeSignInUri(i)" *ngIf="!showEditButton">
                            <span class="fa fa-trash-o"></span>
                        </button>
                    </div>
                </div>
                <button type="button" class="btn btn-primary mt-1 mb-1" (click)="addNewSignInUri()" *ngIf="!showEditButton">Add URI</button>
            </div>
        </div>

        <div class="row" [ngClass]="showEditButton ? 'disable-click' : 'enable-click'">
            <div class="mt-2" style="margin-right: 2.3rem !important;">
                <label for="signOutUri">Sign-out redirect URIs</label>
            </div>
            <div>
                <div formArrayName="signOutRedirectUris" *ngFor="let uri of oktaConfigurationForm.get('signOutRedirectUris')['controls']; let i = index;">
                    <div [formGroupName]="i">
                        <input style="width: 400px;" class="p-1" type="text" formControlName="signOutUri" [ngClass]="{'mt-2': showEditButton, 'mb-2' : showEditButton }">
                        <button class="ml-2 mt-1 mb-1 btn btn-danger" (click)="removeSignOutUri(i)" *ngIf="!showEditButton">
                            <span class="fa fa-trash-o"></span>
                        </button>
                    </div>
                </div>
                <button type="button" class="btn btn-primary mt-1 mb-1" (click)="addNewSignOutUri()" *ngIf="!showEditButton">Add URI</button>
            </div>
        </div>

        <div class="row">
            <button [disabled]="!oktaConfigurationForm.valid" type="button" class="btn btn-primary" type="submit" *ngIf="editableForm">Create</button>
            <button [disabled]="!oktaConfigurationForm.valid" type="button" class="btn btn-primary" type="submit" *ngIf="!editableForm && editing">Save</button>
            <button type="button" class="btn btn-cancel" (click)="back()">Cancel</button>
        </div>

    </form>

    <!-- Result modal for Okta Configurations -->
    <ng-template #modalContent let-closeResult="close" let-dismissResult="dismiss">

        <div class="modal-body ml-4 mr-2">
            <div class="row mt-1 mb-1">
                <h1> Okta settings </h1>
            </div>

            <div class="row m3-2 mb-3">
                <p>
                    Created an application for {{ customerName }} in Okta.
                    Please share the following settings with the product configuration teams to enable SSO.
                </p>
            </div>

            <div class="row mt-3 mb-3">
                <p> Please note the <b>Client Secret</b> will not be available in ECT once this modal is closed and you would need to login to Okta admin console to get them later. </p>
            </div>

            <div class="row mt-3 mb-3">
               <div class="col-md-4 col-lg-4 col-xl-2">ClientId: </div>
               <div class="col-md-4 col-lg-4 col-xl-8">{{ clientId }}</div>
               <div class="col-md-4 col-lg-4 col-xl-2">
                    <span style="cursor: pointer;" (click)="copyText(typeOfData.ClientID)">
                        <span style="color: blue;" class="fa fa-clipboard"></span> copy
                    </span>
                </div>
            </div>

            <div class="row mt-3 mb-3">
                <div class="col-md-3 col-lg-2 col-xl-2">Client Secret: </div>
                <div class="col-md-6 col-lg-8 col-xl-8">{{ clientSecret }} </div>
                <div class="col-md-3 col-lg-2 col-xl-2">
                    <span style="cursor: pointer;" (click)="copyText(typeOfData.ClientSecret)">
                        <span style="color: blue;" class="fa fa-clipboard"></span> copy
                    </span>
                </div>
            </div>

            <div class="row mt-3 mb-3">
                <div class="col-md-3 col-lg-2 col-xl-2">Issuer: </div>
                <div class="col-md-6 col-lg-8 col-xl-8">{{ issuer }} </div>
                <div class="col-md-3 col-lg-2 col-xl-2">
                    <span style="cursor: pointer;" (click)="copyText(typeOfData.Issuer)">
                        <span style="color: blue;" class="fa fa-clipboard"></span> copy
                    </span>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <button type="button" class="btn btn-cancel" (click)="closeResult()">Close</button>
        </div>

    </ng-template>

    <div class="spinner" *ngIf="loading">
      <div class="lspinner"></div>
    </div>

    <ng-template #modalContent1 let-closeResult="close" let-dismissResult="dismiss">

        <div class="modal-body ml-4 mr-2">
            <div>
                <div class="mt-2 mb-2">
                    Replace the product specific URLs where needed and enter the sign-in /sign-out URIs.
                </div>
                <div class="mt-2 mb-2">
                    Please get the sign-in/signout redirect URIs from the product development teams for the products not listed here.
                </div>
                <div class="mt-2 mb-2"><span class="font-weight-bold">Sign-in Sample uri's below </span></div>
                <div class="mt-3 mb-3">
                    <div><span class="font-weight-bold">SNF :</span></div>
                    <div [innerHTML]="info[0]"></div>
                    <div [innerHTML]="info[1]"></div>
                </div>
                <div class="mt-3 mb-3">
                    <div><span class="font-weight-bold">CA :</span></div>
                    <div [innerHTML]="info[2]"></div>
                    <div [innerHTML]="info[3]"></div>
                    <div [innerHTML]="info[4]"></div>
                </div>
                <div class="mt-3 mb-3">
                    <div><span class="font-weight-bold">SL :</span></div>
                    <div [innerHTML]="info[5]"></div>
                    <div [innerHTML]="info[6]"></div>
                </div>
                <div class="mt-3 mb-3">
                    <div><span class="font-weight-bold">Intake :</span></div>
                    <div [innerHTML]="info[7]"></div>
                    <div [innerHTML]="info[8]"></div>
                </div>
                <div class="mt-3 mb-3">
                    <div><span class="font-weight-bold">Meal Tracker :</span></div>
                    <div [innerHTML]="info[9]"></div>
                </div>
                <div class="mt-2 mb-2"><span class="font-weight-bold">Sign-out Sample uri's below </span></div>
                <div class="mt-2 mb-2">
                    <div><span class="font-weight-bold">SNF :</span></div>
                    <div [innerHTML]="info[10]"></div>
                    <div [innerHTML]="info[11]"></div>
                </div>
                <div class="mt-2 mb-2">
                    <div><span class="font-weight-bold">CA :</span></div>
                    <div [innerHTML]="info[12]"></div>
                </div>
                <div class="mt-2 mb-2">
                    <div><span class="font-weight-bold">SL :</span></div>
                    <div [innerHTML]="info[13]"></div>
                    <div [innerHTML]="info[14]"></div>
                </div>
                <div class="mt-2 mb-2">
                    <div><span class="font-weight-bold">Intake :</span></div>
                    <div [innerHTML]="info[15]"></div>
                    <div [innerHTML]="info[16]"></div>
                    <div [innerHTML]="info[17]"></div>
                </div>
                <div class="mt-2 mb-2">
                    <div><span class="font-weight-bold">Meal Tracker :</span></div>
                    <div [innerHTML]="info[18]"></div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-cancel" (click)="closeResult()">Close</button>
        </div>

    </ng-template>
</div>
